<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="row">
          <div class="col-12 text-center">
            <img
              src="@/assets/images/mascot-logo.png"
              alt
              class="img-fluid"
              style="width: 340px"
            />
          </div>
          <div class="col-12 login-loading mt-4" v-show="isAuthStateLoading">
            <div class="row">
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>O</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                  ></div>
                </div>
                <div
                  class="row justify-content-center text-secondary"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-warning" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-warning"
                  style="margin-top: -25px"
                >
                  <strong>I</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-info" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-info"
                  style="margin-top: -25px"
                >
                  <strong>C</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-dark" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-dark"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-primary"
                  style="margin-top: -25px"
                >
                  <strong>M</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-muted" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-muted"
                  style="margin-top: -25px"
                >
                  <strong>A</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>T</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row justify-content-center mt-4">
                  <button
                    v-if="timerCount == 0"
                    type="button"
                    class="btn relative btn-light btn-outline-info"
                    style="width: 260px"
                    @click="$router.push({ name: 'logout' })"
                  >
                    BACK TO LOGIN
                    <i
                      class="fas fa-chevron-left absolute"
                      style="left: 10px; top: 10px"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="isAuthError">
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-4"
              dismissible
              >{{ authError }}</b-alert
            >
          </div>
        </div>
        <!-- end card -->
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import axios from "axios";
const qs = require("querystring");
import * as jwt from "@/helpers/utils/jwt";
import appConfig from "@/app.config";
import * as date from "@/helpers/utils/date";
import { authMethods, layoutMethods } from "@/state/helpers";

export default {
  page: {
    title: "KC Callback",
    meta: [{ name: "Login loading...", content: appConfig.description }],
  },
  components: {},
  data() {
    return {
      timerCount: 10,
      authError: null,
      isAuthStateLoading: true,
      isAuthError: false,
      keyCloakConfig: {
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
        grantType: "authorization_code",
        redirect_uri: `${process.env.VUE_APP_BASE_URL}/login/kc/callback`,
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.code) {
      this.getAccessToken(this.$route.query.code);
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            // console.log(this.timerCount)
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    ...authMethods,
    ...layoutMethods,
    async getAccessToken(authorizeCode) {
      const data = {
        client_id: this.keyCloakConfig.clientId,
        grant_type: "authorization_code",
        code: authorizeCode,
        redirect_uri: this.keyCloakConfig.redirect_uri,
      };

      let vm = this;
      const formData = qs.stringify(data);
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      //console.log("getAccessToken :>> ", authorizeCode);
      axios
        .post(
          `${process.env.VUE_APP_BASE_API}api/v1/Authentications/token/KeyCloak`,
          formData,
          config
        )
        .then(
          function (result) {
            if (
              result.status === 201
            ) {
              var decodeRf = jwt.getUserInfo(result.data.oauthRefreshToken);
              var decodeAt = jwt.getUserInfo(result.data.oauthAccessToken);
              vm.$cookies.set(
                ".oauth.rt",
                result.data.oauthRefreshToken,
                date.differentTimeMinutes(decodeRf.exp) * 60
              );
              vm.$cookies.set(
                ".oauth.at",
                result.data.oauthAccessToken,
                date.differentTimeMinutes(decodeAt.exp) * 60
              );
              
              vm.$cookies.set(
                ".at",
                result.data.accessToken,
                date.differentTimeMinutes(decodeAt.exp) * 60
              );
              vm.setAuthProvider({ authProvider: 'keycloak' });
              vm.setIsAuthenticated({ isAuthenticated: true });
              vm.setAccessToken({ accessToken: result.data.accessToken });
              vm.setOAuthAccessToken({ oauthAccessToken: result.data.oauthAccessToken });
              vm.setOAuthRefreshToken({ oauthRefreshToken: result.data.oauthRefreshToken });
              let info = JSON.stringify({
                name: decodeAt.name,
                email: decodeAt.email,
                photo: '',
              });
              vm.$cookies.set(
                ".oauth.usr",
                info,
                date.differentTimeMinutes(decodeAt.exp) * 60
              );

              vm.changeLayoutType({ layoutType: "horizontal" });
              vm.$router.push({ path: "/" });
            }
          },
          (error) => {
            console.log(error.response);
          }
        )
        .catch((error) => {
          // Handle the error
        });
    },
  },
};
</script>
